<template>
    <div class="" id="Brand">
        <mt-header fixed title="品牌">
            <mt-button @click="goback" slot="left" icon="back">返回</mt-button>
        </mt-header>
        <!-- <div class="hotbrand">
            <h1>热门品牌</h1>
            <div class="brand">
                <ul>
                    <li @click="onChooseBrandId('1212')">
                        <img src="static/image/vw@2x.png" alt="">
                        <span>大众</span>
                    </li>
                    <li>
                        <img src="static/image/vw@2x.png" alt="">
                        <span>大众</span>
                    </li>
                    <li>
                        <img src="static/image/vw@2x.png" alt="">
                        <span>大众</span>
                    </li>
                    <li>
                        <img src="static/image/vw@2x.png" alt="">
                        <span>大众</span>
                    </li>
                    <li>
                        <img src="static/image/vw@2x.png" alt="">
                        <span>大众</span>
                    </li>
                    <li>
                        <img src="static/image/vw@2x.png" alt="">
                        <span>大众</span>
                    </li>
                    <li>
                        <img src="static/image/vw@2x.png" alt="">
                        <span>大众</span>
                    </li>
                    <li>
                        <img src="static/image/vw@2x.png" alt="">
                        <span>大众</span>
                    </li>
                    <li>
                        <img src="static/image/vw@2x.png" alt="">
                        <span>大众</span>
                    </li>
                    <li>
                        <img src="static/image/vw@2x.png" alt="">
                        <span>大众</span>
                    </li>
                </ul>
                <div class="clearfix"></div>
            </div>
        </div>
        <div class="hotbrand" style="margin-top:0;">
            <h1>热门车系</h1>
            <div class="brand system">
                <ul>
                    <li>
                        <span>福克斯</span>
                    </li>
                    <li>
                        <span>凯美瑞</span>
                    </li>
                    <li>
                        <span>轩逸</span>
                    </li>
                    <li>
                        <span>朗逸</span>
                    </li>
                    <li>
                        <span>雅阁</span>
                    </li>
                    <li>
                        <span>卡罗拉</span>
                    </li>
                    <li>
                        <span>速腾</span>
                    </li>
                    <li>
                        <span>捷达</span>
                    </li>
                    <li>
                        <span>花冠</span>
                    </li>
                    <li>
                        <span>天籁</span>
                    </li>
                </ul>
                <div class="clearfix"></div>
            </div>
        </div> -->
        <mt-index-list>
            <mt-index-section index="*">
                <mt-cell>
                    <div @click="onChooseBrandId()">
                        <span>不限品牌</span>
                    </div>
                </mt-cell>
            </mt-index-section>
            <mt-index-section v-for="(item,key) in resData" v-bind:key="key" :index="key">
                <mt-cell v-for="(v,k) in item" v-bind:key="k">
                    <div @click="onChooseBrandId(v.brandId)">
                        <img v-lazy="v.smallLogoPic" />
                        <span>{{v.brandName}}</span>
                    </div>
                </mt-cell>
            </mt-index-section>
            <!-- <mt-index-section index="B">
                <mt-cell>
                    <img src="static/image/vw@2x.png" alt="">
                    <span>大众</span>
                </mt-cell>
                <mt-cell>
                    <img src="static/image/vw@2x.png" alt="">
                    <span>大众</span>
                </mt-cell>
                <mt-cell>
                    <img src="static/image/vw@2x.png" alt="">
                    <span>大众</span>
                </mt-cell>
            </mt-index-section> -->
        </mt-index-list>
        <div class="car_system" style="display:none">
            <div class="box">
                <ul>
                    <li>不限车系</li>
                    <li>奥迪A3</li>
                    <li>奥迪A4</li>
                    <li>奥迪A4L</li>
                    <li>奥迪A6</li>
                    <li>奥迪A6L新能源</li>
                    <li>不限车系</li>
                    <li>奥迪A3</li>
                    <li>奥迪A4</li>
                    <li>奥迪A4L</li>
                    <li>奥迪A6</li>
                    <li>奥迪A6L新能源</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { Header, IndexList, IndexSection, Toast, Indicator } from "mint-ui";
import { API_GET, API_POST, getLocationm, URI} from "@/apiConfig";
export default {
    name: "Brand",
    data() {
        return {
            msg: "Welcome to Your Vue.js App",
            resData: {},
            resList: [],
            pageSource: "" // 从哪个页面入口的
        };
    },
    mounted() {
        // console.log(this.$route.params, "this.$route.params");
        if (this.$route.params.pageSource) {
            this.pageSource = this.$route.params.pageSource;
        }
        // console.log(this.pageSource, "this.pageSource");
        this.fetchData();
        window.scroll(0, 0);
    },
    methods: {
        goback: function() {
            window.history.go(-1);
        },

        fetchData: function() {
            // 获取车辆品牌接口
            Indicator.open();
            API_POST(
                URI + "/lianlianche-car/brand/listAllBrand",
                {},
                true
            ).then(res => {
                Indicator.close();
                if (res.status == 0) {
                    if (Array.isArray(res.data)) {
                        let obj = {};
                        res.data.forEach(v => {
                            if (v.initial in obj) {
                            } else {
                                obj[v.initial] = [];
                            }
                        });
                        res.data.forEach((v, index) => {
                            for (let key in obj) {
                                if (v.initial == key) {
                                    obj[key].push(v);
                                }
                                // console.log('key',key)
                            }
                        });
                        console.log(" obj", obj);
                        this.resData = obj;
                        // console.log(' this.resData', this.resData)
                    }
                } else {
                    Toast({
                        message: res.msg
                    });
                }
            });
        },
        onChooseBrandId: function(brandId) {
            // 点击选择的品牌
            console.log(brandId);
            if (this.pageSource) {
                // 如果从某个页面过来的，则把 carBrandId 带回去
                this.$router.push({
                    name: this.pageSource,
                    query: { carBrandId :brandId}
                });
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
    color: #2c2c2c;
}
</style>



// WEBPACK FOOTER //
// src/components/Brand.vue